<template>
  <div>
    <div class="box" id="echartsView"></div>

    <div class="box1" v-if="false">
      <timechangpage></timechangpage>
    </div>
  </div>
</template>
<script>
import worldJson from "../utils/world.json";
import chinaJson from "../utils/china.json";
import * as echarts from "echarts";
export default {
  props: {
    chartstype: {
      type: [Number, String],
      value: 1,
    },
    thetype: {
      type: [Number, String],
      value: 1, //1 按主题 2 按国家
    },
    maptype: {
      type: [Number, String],
      value: 1,
    },
    chartData: {
      //数据
      // categories: 横轴坐标
      // series：数据
      type: Object,
      value: {},
    },
  },
  data() {
    return {
      fontSize: "",
      chartDom: "",
      myEchart: "",
    };
  },
  watch: {
    thetype() {
      const that = this;
      this.initChatrs();
    },
    chartstype() {
      const that = this;
      this.initChatrs();
    },
    chartData() {
      this.initChatrs();
    },
  },
  created() {
    const that = this;
    that.fontSize = that.getRem(1920, 1080, 100);
    window.addEventListener("resize", function () {
      that.fontSize = that.getRem(1920, 1080, 100);
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.initChatrs();
    });
  },
  methods: {
    initChatrs() {
      const that = this;

      this.$nextTick(function () {
        that.chartDom = document.getElementById("echartsView");
        that.myEchart = echarts.init(that.chartDom, null, { renderer: 'canvas' });
        window.addEventListener("resize", function () {
          that.myEchart && that.myEchart.resize();
        });
         console.log(that.maptype,'that.maptypethat.maptype')
        if (that.chartstype == 1) {
          this.zzEchart();
        } else if (that.chartstype == 2) {
          this.zxEchart();
        } else if (that.chartstype == 3) {
          this.bzEchart();
        } else if (that.chartstype == 4) {
          this.qpEchart();
        } else if (that.chartstype == 5) {
          this.sdEchart();
        } else if (that.chartstype == 6) {
          this.ldEchart();
        } else if (that.chartstype == 7) {
          this.jxEchart();
        } else if (
          (that.chartstype == 8 && that.maptype == 1) ||
          (that.chartstype == 8 && that.maptype == 3)
        ) {
          this.dtEchart();
        } else if (that.chartstype == 8 && that.maptype == 2) {
          this.dtEchart1();
        }
      });
    },
    getRem(pwidth, pheight, prem) {
      let fontSize;
      var html = document.getElementsByTagName("html")[0];
      var oHeight = window.innerHeight;
      var oWidth = window.innerWidth;
      let pd = pheight / pwidth;
      let tpd = oHeight / oWidth;
      if (tpd < pd) {
        html.style.fontSize = (oHeight / pheight) * prem + "px";
        fontSize = (oHeight / pheight) * prem;
      } else {
        html.style.fontSize = (oWidth / pwidth) * prem + "px";
        fontSize = (oWidth / pwidth) * prem;
      }
      return fontSize;
    },
    zzEchart() {
      const that = this;

      let chartData = JSON.parse(JSON.stringify(this.chartData));
      let series = [];
      if (chartData.series) {
        chartData.series.forEach((item) => {
          let data = item;
          data["type"] = data["type"] || "bar";
          series.push(data);
        });
      }
      let option = {
        legend: {},
        grid: {
          left: "10%",
          right: "5%",
          top: "10%",
          bottom: "5%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: chartData.categories || [],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: series,
      };
      console.log("that.myEchart:", that.myEchart);
      option && that.myEchart.setOption(option, true);
    },
    zxEchart() {
      var that = this;
      let chartData = JSON.parse(JSON.stringify(this.chartData));
      let series = [];
      if (chartData.series) {
        chartData.series.forEach((item) => {
          let data = item;
          data["type"] = "line";
          series.push(data);
        });
      }
      let option = {
        legend: {},
        grid: {
          left: "5%",
          right: "5%",
          top: "10%",
          bottom: "5%",
        },
        tooltip: {
          trigger: "item",
        },
        xAxis: {
          type: "category",
          data: chartData.categories || [],
        },
        yAxis: {
          type: "value",
        },
        series: series,
      };
      option && that.myEchart.setOption(option, true);
    },
    bzEchart() {
      var that = this;

      let chartData = JSON.parse(JSON.stringify(this.chartData));
      let datas = [];
      if (chartData.series) {
        chartData.series.forEach((item, index) => {
          let value = 0;
          item.data.forEach((vitem) => {
            value += vitem;
          });
          datas.push({
            name: item.name,
            value,
          });
        });
      }
      let option = {
        legend: {},
        grid: {
          left: "5%",
          right: "5%",
          top: "10%",
          bottom: "5%",
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: "80%",
            data: datas,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      option && that.myEchart.setOption(option, true);
    },

    qpEchart() {
      var that = this;

      let chartData = JSON.parse(JSON.stringify(this.chartData));
      var datalist = chartData.data
      var type = chartData.type  //1科技金融广场  2 商品贸易 3进出口 4行业数据
      var namelist = [];
     
      const hours = chartData.categories
      var ttlist = []
      var min = 0
      var max = 0
      if (chartData.series.length) {
        chartData.series.map(item => {
          if (JSON.stringify(namelist).indexOf(item.name) == -1) {
            namelist = namelist.concat(item.name)
          }
        })

        
        console.log(datalist,'datalist')
        console.log(hours,'hours')
        console.log(namelist,'namelist')
         
        datalist.map((item, index) => {
          if(item.time==chartData.year){
            var tt = 0
          var tt1 = 0
           
          if(type==1){
            hours.map((hitem, hindex) => {
            if (item.elementName == hitem) {
              tt = hindex
            }
          })
              namelist.map((nitem, nindex) => {
              if (nitem == item.areaName) {
                tt1 = nindex
              }
            })
          }else if(type==2||type==3){
            if(type==2){
              hours.map((hitem, hindex) => {
            if (item.itemName == hitem) {
              tt = hindex
            }
          })
            }else{
              hours.map((hitem, hindex) => {
            if (item.areaName == hitem) {
              tt = hindex
            }
          })
            }
              namelist.map((nitem, nindex) => {
              if (nitem == item.elementName) {
                tt1 = nindex
              }
            })
          }else if(type==4){
            hours.map((hitem, hindex) => {
            if (item.themName == hitem) {
              tt = hindex
            }
          })
            namelist.map((nitem, nindex) => {
              if (nitem == item.themName) {
                tt1 = nindex
              }
            })
          }
           
          if(max<item.value){
            max = item.value
          }
          if(min>item.value){
            min = item.value
          }
          var data = [tt, tt1, item.value]
              ttlist.push(data)
          }
        })
      }

      
      console.log(ttlist,'chartDatachartDatachartData')
      // prettier-ignore
      const days = namelist;
      // prettier-ignore
      const data = ttlist
      console.log(ttlist,'datalistdatalistdatalist')
      let option = {
        grid: {
          left: "5%",
          right: "5%",
          top: "10%",
          bottom: "5%",
        },
        tooltip: {
          position: "top",
          formatter: function (params) {
            return (
              
              days[params.value[1]]+'：'+params.value[2]
            );
          },
        },

        xAxis: {
          type: "category",
          data: hours,
          boundaryGap: false,
          splitLine: {
            show: true,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          data: days,
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            // name: "Punch Card",
            type: "scatter",
            symbolSize: function (val) {
              return val[2] * 2>80?80:val[2] * 2>20?val[2] * 2:20;
            },
            data: data,
            animationDelay: function (idx) {
              return idx * 5;
            },
          },
        ],
      };
      option && that.myEchart.setOption(option, true);
    },
    sdEchart() {
      var that = this;
      let chartData = JSON.parse(JSON.stringify(this.chartData));
      let series = [];
      if (chartData.series) {
        chartData.series.forEach((item) => {
          let data = item;
          data["type"] = data["type"] || "scatter";
          series.push(data);
        });
      }
      let option = {
        legend: {},
        grid: {
          left: "5%",
          right: "5%",
          top: "10%",
          bottom: "5%",
        },
        xAxis: [
          {
            type: "category",
            data: chartData.categories || [],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: {},
        series: series
      };
      option && that.myEchart.setOption(option, true);
    },
    ldEchart() {
      var that = this;

      let chartData = JSON.parse(JSON.stringify(this.chartData));
      let datas = [],
        radars = [];
      let max = 0;
      if (chartData.series) {
        chartData.series.forEach((item, index) => {
          item.data.forEach((vitem, vindex) => {
            if (vitem > max) {
              max = vitem;
            }
            if (radars[vindex]) {
              radars[vindex]["max"] =
                radars[vindex]["max"] < vitem ? vitem : radars[vindex]["max"];
            } else {
              radars[vindex] = {
                name: chartData.categories[vindex],
                max: vitem,
              };
            }
          });

          datas.push({
            name: item.name,
            value: item.data,
          });
        });
      }
      console.log(datas, 'datasdatasdatas')
      radars.map((item) => {
        item["max"] = max;
      });

      let option = {
        legend: {},
        grid: {
          left: "5%",
          right: "5%",
          top: "10%",
          bottom: "5%",
        },
        tooltip: {
          trigger: "item",
        },
        radar: {
          // shape: 'circle',
          indicator: radars,
        },
        series: [
          {
            name: "",
            type: "radar",
            data: datas,
          },
        ],
      };
      option && that.myEchart.setOption(option, true);
    },
    jxEchart() {
      var that = this;
      let chartData = JSON.parse(JSON.stringify(this.chartData));
      var datalist = chartData.data
      var type = chartData.type  //1科技金融广场  2 商品贸易 3进出口 4行业数据
      var namelist = [];
      console.log(chartData.categories,'chartDatachartDatachartData')
      const hours = chartData.categories
      var ttlist = []
      var min = 0
      var max = 0
      if (chartData.series.length) {
        chartData.series.map(item => {
          if (JSON.stringify(namelist).indexOf(item.name) == -1) {
            namelist = namelist.concat(item.name)
          }
        })

        
        console.log(datalist,'datalist')
        console.log(hours,'hours')
        console.log(namelist,'namelist')
         
        datalist.map((item, index) => {
          if(item.time==chartData.year){
            var tt = 0
          var tt1 = 0
           
          if(type==1){
            hours.map((hitem, hindex) => {
            if (item.elementName == hitem) {
              tt = hindex
            }
          })
              namelist.map((nitem, nindex) => {
              if (nitem == item.areaName) {
                tt1 = nindex
              }
            })
          }else if(type==2||type==3){
            if(type==2){
              hours.map((hitem, hindex) => {
            if (item.itemName == hitem) {
              tt = hindex
            }
          })
            }else{
              hours.map((hitem, hindex) => {
            if (item.areaName == hitem) {
              tt = hindex
            }
          })
            }
              namelist.map((nitem, nindex) => {
              if (nitem == item.elementName) {
                tt1 = nindex
              }
            })
          }else if(type==4){
            hours.map((hitem, hindex) => {
            if (item.themName == hitem) {
              tt = hindex
            }
          })
            namelist.map((nitem, nindex) => {
              if (nitem == item.themName) {
                tt1 = nindex
              }
            })
          }
           
          if(max<item.value){
            max = item.value
          }
          if(min>item.value){
            min = item.value
          }
          var data = [tt, tt1, item.value]
              ttlist.push(data)
          }
        })
      }

      console.log(ttlist, 'chartDatachartData')
      // prettier-ignore

      const days = namelist;
      // prettier-ignore
      //       const data = ttlist
      //     .map(function (item) {
      //     return [item[1], item[0], item[2] || '-'];
      // });
      let option = {
        grid: {
          left: "10%",
          right: "5%",
          top: "10%",
          bottom: "5%",
        },
        tooltip: {
          position: "top",
          trigger: "item",
        },
        xAxis: {
          type: "category",
          data: hours,
          splitArea: {
            show: true,
          },
        },
        yAxis: {
          type: "category",
          data: days,
          splitArea: {
            show: true,
          },
        },
        visualMap: { 
          min:min,
          max:max,
          calculable: true,
          type: "piecewise",
          realtime: false,
          orient: "horizontal",
          left: "center",
          top: "0%",
          inRange: {
            color: ["#a3b5fa", "#889ff8", "#6e8af7", "#5979f5"],
          },
        },
        series: [
          {
            // name: "Punch Card",
            type: "heatmap",
            data: ttlist,
            label: {
              show: true, 
            },
            emphasis: {
              label: {
                show: true, 
              },
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      option && that.myEchart.setOption(option, true);
    },
    dtEchart() {
      var that = this;
      echarts.registerMap("world", worldJson);
      let chartData = JSON.parse(JSON.stringify(this.chartData));
      var datalist = chartData.data
      var type = chartData.type  //1科技金融广场  2 商品贸易 3进出口 4行业数据
      var year = chartData.year
     
      var detail = datalist.reverse()
      console.log(chartData.year,detail,'datalistdatalistdatalist')
            var arealist = []
            var datalist = []
            var max = 0
            detail.map(item=>{
                if(JSON.stringify(arealist).indexOf(item.areaName)==-1){
                    arealist = arealist.concat(item.areaName)
                }
            })
            arealist.map(item=>{
                var value = 0
                var list = []
                detail.map(eitem=>{
                    if(eitem.areaName==item&&year==eitem.time){
                        value = eitem.value
                    }
                })
                if(max<value){
                    max = value
                }
                datalist = datalist.concat({
                    name:item,
                    value:value,
                    list:list.reverse()
                })
            })


      var series = [
        {
          name: "",
          type: "map",
          geoIndex: 0,

          data: datalist,
        },
      ];
      // if (that.maptype == 3) {
      //   series = series.concat({
      //     type: "lines",
      //     coordinateSystem: "geo",
      //     effect: {
      //       show: true,
      //       trailWidth: 1,
      //       color: "#f4791e",
      //       trailOpacity: 2,
      //       trailLength: 2,
      //       constantSpeed: 5,
      //       symbol: "arrow",
      //       symbolSize: 5,
      //     },
      //     data: [
      //       [
      //         [39.956589, 43.449928],
      //         [49.278728, 55.606186],
      //       ],
      //       [
      //         [48.006278, 46.283333],
      //         [49.278728, 55.606186],
      //       ],
      //       [
      //         [48.006278, 46.283333],
      //         [43.081889, 44.225072],
      //       ],
      //       [
      //         [61.503333, 55.305836],
      //         [49.278728, 55.606186],
      //       ],
      //       [
      //         [61.503333, 55.305836],
      //         [82.650656, 55.012622],
      //       ],
      //     ],
      //     large: true,
      //     largeThreshold: 100,
      //     lineStyle: {
      //       opacity: 5,
      //       width: 1,
      //       color: "#f4791e",
      //       curveness: 0.3,
      //     },
      //     blendMode: "lighter",
      //   });
      // }

      let option = {
        color: ["#000000"],
        tooltip: {
          triggerOn: "mousemove,click", //mousemove、click
          // padding: 0,

          borderWidth: 1,
          enterable: true,
          // triggerOn: 'click',
          // alwaysShowContent:false,
          borderColor: "rgba(0,0,0,0)",
          // backgroundColor: 'rgba(255,255,255,0.7)',
          textStyle: {
            color: "#000000",
            fontSize: 13,
          },
          formatter: function (e, t, n) {
                let data = e.data;
                if (data) {
                let context = `
                    <div>
                      ${data.name}：${data.value}
                    </div>
                    `
                return context;
                }else{
                  return ''
                }

            }
        },
        visualMap: {
            show: true,
            left: 0,
            bottom: 40,
            showLabel: true,
            max: max,
            min:0,
            type: "piecewise",
            calculable: true,
            realtime: false,
            formatter: function (value, value2) {
                 return parseInt(value) + "-" + parseInt(value2); // 范围标签显示内容。
            },
            inRange: {
              color: [
              "#d2e3ff",
              "#2f9aff",
              "#0762ff",
              "#0135d8",
              "#0125a0",
              ],
            }
          },
        geo: {
          map: "world",
          scaleLimit: {
            min: 1.2,
            max: 2,
          },
          zoom: 1.2,
          top: 50,
          label: {
            normal: {
              show: false,
              fontSize: "14",
              color: "rgba(0,0,0,0.7)",
            },
          },

          itemStyle: {
            normal: {
              //shadowBlur: 50,
              //shadowColor: 'rgba(0, 0, 0, 0.2)',
              borderColor: "rgba(0, 0, 0, 0.2)",
              color: "#b5caff",
            },
            emphasis: {
              areaColor: "#3970ff",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0,
            },
          },
        },
        select: {
          itemStyle: {
            areaColor: "#d2e3ff",
          },
        },
        series: series,
      };

      option && that.myEchart.setOption(option, true);
    },
    dtEchart1() {
      var that = this;
      echarts.registerMap("china", chinaJson);

      let chartData = JSON.parse(JSON.stringify(this.chartData));
      var datalist = chartData.data
      var type = chartData.type  //1科技金融广场  2 商品贸易 3进出口 4行业数据
      var year = chartData.year
     
      var detail = datalist.reverse()
      console.log(chartData.year,detail,'datalistdatalistdatalist')
            var arealist = []
            var datalist = []
            var max = 0
            detail.map(item=>{
                if(JSON.stringify(arealist).indexOf(item.areaName)==-1){
                    arealist = arealist.concat(item.areaName)
                }
            })
            arealist.map(item=>{
                var value = 0
                var list = []
                detail.map(eitem=>{
                    if(eitem.areaName==item&&year==eitem.time){
                        value = eitem.value
                    }
                })
                if(max<value){
                    max = value
                }
                datalist = datalist.concat({
                    name:item,
                    value:value,
                    list:list.reverse()
                })
            })
      let option = {
        color: ["#000000"],
        tooltip: {
          triggerOn: "mousemove,click", //mousemove、click
          padding: 8,
          borderWidth: 1,
          enterable: true,
          // triggerOn: 'click',
          // alwaysShowContent:false,
          borderColor: "rgba(0,0,0,0)",
          // backgroundColor: 'rgba(255,255,255,0.7)',
          textStyle: {
            color: "#000000",
            fontSize: 13,
          },
          formatter: function (e, t, n) {
                let data = e.data;
                if (data) {
                let context = `
                    <div>
                      ${data.name}：${data.value}
                    </div>
                    `
                return context;
                }else{
                  return ''
                }

            }
        },
        visualMap: {
          show: true,
          left: 26,
          bottom: 40,
          showLabel: true,
          max: max,
          min: 0,
          type: "piecewise",
          calculable: true,
          realtime: false,
          formatter: function (value, value2) {
            return parseInt(value) + "-" + parseInt(value2); // 范围标签显示内容。
          },
          inRange: {
            color: ["#d2e3ff", "#2f9aff", "#0762ff", "#0135d8", "#0125a0"],
          },
        },

        geo: {
          map: "china",
          scaleLimit: {
            min: 1.2,
            max: 2,
          },
          zoom: 1.2,
          top: 50,
          label: {
            normal: {
              show: true,
              fontSize: "14",
              color: "rgba(0,0,0,0.7)",
            },
          },

          itemStyle: {
            normal: {
              //shadowBlur: 50,
              //shadowColor: 'rgba(0, 0, 0, 0.2)',
              borderColor: "rgba(0, 0, 0, 0.2)",
              color: "#b5caff",
            },
            emphasis: {
              areaColor: "#3970ff",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0,
            },
          },
        },
        select: {
          itemStyle: {
            areaColor: "#d2e3ff",
          },
        },
        series: [
          {
            name: "",
            type: "map",
            geoIndex: 0,

            data:datalist
          },
        ],
      };
      option && that.myEchart.setOption(option,true);
    },
    saveImage(fileName) {
      var resBase64 = this.myEchart.getDataURL({
        type: "png", // 导出的格式，可选 png, jpeg
        pixelRatio: 2,
        backgroundColor: "#fff",
        excludeComponents: ["toolbox"],
      });
      console.log("resBase64:", resBase64);
      const elink = document.createElement("a");
      elink.download = fileName + ".png";
      elink.style.display = "none";
      elink.href = resBase64;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 500px;
  padding: 0 30px;
}

.box1 {
  padding: 10px 30px;
}
</style>



// WEBPACK FOOTER //
// chart.vue?ff710626